import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for creating a Confluence space.
 */

/**
 * Properties for the Confluence space creation command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to create a new Confluence space.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence space with the specified content.
 */
export var ConfluenceSpaceCreateCommand = createCommand('confluence-space-create-command');